import * as React from 'react';
import { Text, Heading } from '@wix/design-system';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { RootStore, withInjectedRootStore } from 'providers';
import { useBreakpoint } from 'providers/BreakpointProvider';
import { Experiments, MediaDevices } from 'enums';
import s from './SideTitle.scss';

interface SideTitleProps {
  rootStore: RootStore;
  titleKey: string;
  subtitleKey?: string;
}

const SideTitleComp: React.FC<SideTitleProps> = ({
  rootStore,
  titleKey,
  subtitleKey,
  children,
}) => {
  const { t } = useTranslation();
  const { currentBreakpoint } = useBreakpoint();
  const isMobile = currentBreakpoint === MediaDevices.Mobile;
  const isMobileTrustEnabled = rootStore.appStore.experiments[Experiments.MobileTrust] === 'true';
  const isCompact = isMobile && isMobileTrustEnabled;

  return (
    <div className={s.sideTitleContainer}>
      <Heading
        className={classNames(s.sideTitleHeading, {
          [s.sideTitleHeadingCompact]: isCompact,
        })}
        appearance='H2'
      >
        {t(titleKey)}
      </Heading>
      {subtitleKey && <Text className={s.sideSubtitle}>{t(subtitleKey)}</Text>}
      {children}
    </div>
  );
};

export const SideTitle = withInjectedRootStore(SideTitleComp);
